//braids.js
export const braids = [
  {
    id: "knotless-boho",
    name: "Knotless Boho",
    basePrice: 300,
    images: [
      "/images/knotless_boho_1.png",
      "/images/knotless_boho_2.png",
      "/images/knotless_boho_3.png",
      "/images/knotless_boho_4.png",
    ],
  },
  {
    id: "cornrows",
    name: "Cornrows",
    basePrice: 250,
    images: [
      "/images/cornrows_1.png",
      "/images/cornrows_2.png",
      "/images/cornrows_3.png",
      "/images/cornrows_4.png"
    ],
  },
  {
    id: "halfCorn-halfSew",
    name: "Half Cornrows, Half Sew-in",
    basePrice: 250,
    images: [
      "/images/half_con_sewing_1.png",
      "/images/half_con_sewing_2.png",
      "/images/half_con_sewing_3.png",
      "/images/half_con_sewing_4.png"
    ],
  },
  {
    id: "knotless-braids",
    name: "Knotless Braids",
    basePrice: 200,
    images: [
      "/images/knotless_1.png",
      "/images/knotless_2.png",
      "/images/knotless_3.png",
    ],
  },
  {
    id: "fulani-braids",
    name: "Fulani Braids",
    basePrice: 200,
    images: [
      "/images/fulani_1.png",
    ]
  },

  {
    id: "stitch-cornrows",
    name: "Stitch Cornrows",
    category: "stitch-cornrows",
    basePrice: 80,
    images: [
      "/images/stitch_corn_1.png",
    ],
  },

  {
    id: "crochet",
    name: "Crochet Braids",
    basePrice: 150,
    images: [
      "/images/crochet_1.png",
    ],
  },

  {
    id: "leave-out-sew-in",
    name: "Leave-out Sew-in",
    basePrice: 120,
    images: [
      "/images/leave_out_sew_1.png",
    ],
  },

  {
    id: "lemonade-braids",
    name: "Lemonade Braids",
    basePrice: 200,
    images: [
      "/images/lemonade_1.png",
      "/images/lemonade_2.png",
      "/images/lemonade_3.png"
    ],
  },

  {
    id: "french-curl-braids",
    name: "French Curl Braids",
    basePrice: 200,
    images: [
      "/images/french_curl_1.png",
    ]
  },

  {
    id: "men-corn-design",
    name: "Men Cornrows with design",
    basePrice: 70,
    category: "mens",
    images: [
      "/images/men_corn_design_1.png",
    ],
  },

  {
    id: "men-cornrows",
    name: "Men Cornrows",
    basePrice: 70,
    category: "mens",
    images: [
      "/images/men_corn_1.png",
    ]
  },

];